"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestWorkspaceSelectInfo = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const WORKSPACE_SELECT_INFO_QUERY = (0, graphql_tag_1.default) `
  query WorkspaceSelectInfo($id: ID!) {
    workspace(id: $id) {
      id
      name
      customId
      enforceLocalities
      country
      localities {
        id
        name
        shortName
        assigns {
          userId
        }
      }
    }
  }
`;
const requestWorkspaceSelectInfo = async (variables) => {
    const { data, errors } = await (0, apollo_1.query)(WORKSPACE_SELECT_INFO_QUERY, { variables });
    (0, error_handler_1.processErrors)(errors);
    return data?.workspace;
};
exports.requestWorkspaceSelectInfo = requestWorkspaceSelectInfo;
